import { render } from "./App.vue?vue&type=template&id=bcf47da0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=bcf47da0&lang=scss"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__